import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './PREAUCT_Investor_Pledge_S.css';

const PREAUCT_Investor_Pledge_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Investor Pledge');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/PREAUCT_Investor_Pledge', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [PREAUCT_INVESTOR_PLEDGE, setPREAUCT_INVESTOR_PLEDGE] = React.useState(null);
  const [PREAUCT_INVESTOR_PLEDGE_S, setPREAUCT_INVESTOR_PLEDGE_S] = React.useState(null);

  var Ids = [];
  for(var Ele in PREAUCT_INVESTOR_PLEDGE_S){
	  for(var Sec in PREAUCT_INVESTOR_PLEDGE_S[Ele]){
			if(Sec == "id")
				Ids.push(PREAUCT_INVESTOR_PLEDGE_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(PREAUCT_INVESTOR_PLEDGE_S[Ele]["status"]);
			else if(Array.isArray(PREAUCT_INVESTOR_PLEDGE_S[Ele][Sec]))
				  for(var Row in PREAUCT_INVESTOR_PLEDGE_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in PREAUCT_INVESTOR_PLEDGE_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE`).then((response) => {
      setPREAUCT_INVESTOR_PLEDGE(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setPREAUCT_INVESTOR_PLEDGE_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!PREAUCT_INVESTOR_PLEDGE_S) return <div>Loading...</div>;

 const handleLastDataPREAUCT_INVESTOR_PLEDGE_S = async (data) => {
  };




  const handleAddPREAUCT_INVESTOR_PLEDGE_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE_S', JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE_S');
      setPREAUCT_INVESTOR_PLEDGE_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  


const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  


const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  

  
      
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  


  
      
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  


  
      
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  



const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["4"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  


const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  

    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE_S(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = PREAUCT_INVESTOR_PLEDGE_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Pre-Auction Investor Pledge')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pledge ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0" type="text" className="form-control" placeholder="PREAUCT Pledge ID"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pledge ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pre Auction Pool ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1" type="text" className="form-control" placeholder="PREAUCT Pre Auction Pool ID"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pre Auction Pool ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2" type="text" className="form-control" placeholder="Investor ID"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Pledge Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3" type="text" className="form-control" placeholder="Pledge Amount USD"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Pledge Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Deposit ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0" type="text" className="form-control" placeholder="Escrow Deposit ID"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Deposit ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"   onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1_Change} className="form-control" name="Payment Method"  >
						  <option value="ACH">ACH</option>
						  <option value="Wire">Wire</option>
						  <option value="Card">Card</option>
						  <option value="Check">Check</option>
						  <option value="Internal Transfer">Internal Transfer</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Method
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"   onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2_Change} className="form-control" name="Payment Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Received">Received</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Failed">Failed</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Paid">Paid</option>
						  <option value="Partially Paid">Partially Paid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Refund Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"   onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3_Change} className="form-control" name="Refund Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Completed">Completed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Refund Status
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Risk Acknowledged`)} <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0_Change} 
					  checked={PREAUCT_INVESTOR_PLEDGE_S?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"] === "true" || PREAUCT_INVESTOR_PLEDGE_S?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Conditional Nature Acknowledged`)} <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1_Change} 
					  checked={PREAUCT_INVESTOR_PLEDGE_S?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"] === "true" || PREAUCT_INVESTOR_PLEDGE_S?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`No Token Until Winning Bid Acknowledged`)} <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2_Change} 
					  checked={PREAUCT_INVESTOR_PLEDGE_S?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"] === "true" || PREAUCT_INVESTOR_PLEDGE_S?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Pledge Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"   onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0_Change} className="form-control" name="Pledge Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Funded">Funded</option>
						  <option value="Accepted">Accepted</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Pledge Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"   onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`PREAUCT Pledge ID`)}</th>
                        <th>{t(`PREAUCT Pre Auction Pool ID`)}</th>
                        <th>{t(`Investor ID`)}</th>
                        <th>{t(`Pledge Amount USD`)}</th>
                        <th>{t(`Escrow Deposit ID`)}</th>
                        <th>{t(`Payment Method`)}</th>
                        <th>{t(`Payment Status`)}</th>
                        <th>{t(`Refund Status`)}</th>
                        <th>{t(`Risk Acknowledged`)}</th>
                        <th>{t(`Conditional Nature Acknowledged`)}</th>
                        <th>{t(`No Token Until Winning Bid Acknowledged`)}</th>
                        <th>{t(`Pledge Status`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {PREAUCT_INVESTOR_PLEDGE_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default PREAUCT_Investor_Pledge_S;  